import { MEAL_TYPE_CONTAINER_ID } from 'common/MealTypeUtils';
import CPG_SHEF_IDS from 'common/shef-profiles/CPGShefs';
import React from 'react';
import { BrowseByMealType } from 'src/pages/consumer/dish-first/explore/components/BrowseBy';
import { useMealTypeMenuBarContext } from 'src/pages/consumer/dish-first/explore/context';
import { BrowseByMealTypeSection } from 'src/pages/consumer/order/shef-menu/styles';
import styled, { css } from 'styled-components';
import { Mixins, Spacing } from 'web-common/src/shared/styles';
import { useShefMenuHeader } from '../../components/DishFirstHeader';
import { ClearFiltersButton } from '../../dish-first/explore/components/ExploreFilterButtons/ClearFiltersButton';
import { DietaryFilterButton } from '../../dish-first/explore/components/ExploreFilterButtons/DietaryFilterButton';
import { MoreFiltersButton } from '../../dish-first/explore/components/ExploreFilterButtons/MoreFiltersButton';
import { ProteinFilterButton } from '../../dish-first/explore/components/ExploreFilterButtons/ProteinFilterButton';
import { ExploreFilterIds } from '../../dish-first/explore/components/ExploreFilters';

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: ${Spacing.SINGLE};
  gap: ${Spacing.THREE_QUARTERS};

  & button {
    transform: translateY(0);
  }

  & div:empty {
    display: none;
  }

  &:not(:empty) {
    ${Mixins.Media.maxWidthMedium(css`
      margin-top: ${Spacing.SINGLE};
    `)}
    ${Mixins.Media.maxWidthSmall(css`
      margin: 0 0 ${Spacing.SINGLE} 0;
    `)}
  }
  ${Mixins.Media.maxWidthLarge(css`
    display: flex;
  `)}
`;
export interface DishFirstConsumerOrderFiltersProps {
  isDishFirst: boolean;
  isEditingOrder: boolean;
  shefId: string;
}

export const DishFirstConsumerOrderFilters: React.FC<DishFirstConsumerOrderFiltersProps> = ({
  isDishFirst,
  isEditingOrder,
  shefId,
}) => {
  const { availableMealTypes } = useMealTypeMenuBarContext();
  const shouldShowFilters = !CPG_SHEF_IDS.includes(shefId);
  const { menuBarRef } = useShefMenuHeader({ showMenuBar: true });

  if (!isDishFirst || isEditingOrder) return null;

  return (
    <>
      <Container id={ExploreFilterIds.FilterButtonRow}>
        {shouldShowFilters && (
          <>
            <ProteinFilterButton />
            <DietaryFilterButton />
            <MoreFiltersButton />
            <ClearFiltersButton />
          </>
        )}
        <BrowseByMealType ref={menuBarRef} />
      </Container>
      {availableMealTypes.length > 1 && <BrowseByMealTypeSection id={MEAL_TYPE_CONTAINER_ID} />}
    </>
  );
};
